export default "__VITE_ASSET__bBeagHXt__"